import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Dropdown, DropdownItem, ColumnManager } from 'shared/components';
import { isEqual } from 'lodash';
import LastPageIcon from 'assets/svgs/lastPageArrow.svg';
import FirstPageIcon from 'assets/svgs/firstPageArrow.svg';
import NextPageIcon from 'assets/svgs/nextArrow.svg';
import PrevPageIcon from 'assets/svgs/prevArrow.svg';
import DropdownArrow from 'assets/svgs/dropdownArrow.svg';
import { RostersAssign } from 'features/rosters';

import './Pagination.scss';

class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.state = { pager: {} };

    this.onChangePageSize = this.onChangePageSize.bind(this);
    this.setPage = this.setPage.bind(this);
    this.getPager = this.getPager.bind(this);
  }

  componentDidMount() {
    // set page if items array isn't empty
    if (this.props.itemsTotalCount > 0) {
      this.setPage(this.props.initialPage);
    }
  }

  componentDidUpdate(prevProps) {
    // reset page if items array has changed
    // if (this.props.items !== prevProps.items) {
    //   this.setPage(this.props.initialPage);
    // }

    if (
      this.props.itemsTotalCount !== prevProps.itemsTotalCount ||
      !isEqual(this.props.paginationDataParams, prevProps.paginationDataParams)
    ) {
      this.setPage(this.props.initialPage);
    }
  }

  setPage(page, pageSizeNew) {
    let { pageSize, itemsTotalCount } = this.props;
    let pager = this.state.pager;

    if (page < 1 || page > pager.totalPages) {
      return;
    }

    // get new pager object for specified page
    pager = this.getPager(itemsTotalCount, page, pageSizeNew || pageSize);

    // get new page of items from items array
    // let pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);

    // update state
    this.setState({ pager: pager });

    // call change page function in parent component
    itemsTotalCount && this.props.onChangePage(pager.startIndex, pager.endIndex, pageSizeNew);

    if (!this.props.hasSearchValue) {
      this.props.setTemporarySearchValue('');
    }
  }

  getPager(totalItems, currentPage, pageSize) {
    // default to first page
    currentPage = currentPage || 1;

    // default page size is 10
    pageSize = pageSize || 10;

    // calculate total pages
    let totalPages = totalItems ? Math.ceil(totalItems / pageSize) : 1;

    const startPage = 1;

    // calculate start and end item indexes
    let startIndex = (currentPage - 1) * pageSize;
    let endIndex = totalItems ? Math.min(startIndex + pageSize - 1, totalItems - 1) : 0;

    // create an array of pages to repeat in the pager control
    let pages = [...Array(totalPages).keys()].map((i) => startPage + i);
    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages,
    };
  }

  onChangePageSize(value) {
    this.setPage(this.props.initialPage, value);
    if (!this.props.hasSearchValue) {
      this.props.setTemporarySearchValue('');
    }
  }

  render() {
    const {
      children,
      showNumbersList,
      showCurrentPage,
      displayHeader,
      pageSizeOptions,
      pageOptionsLabel,
      showSelectPage,
      onReloadExaminees,
      selectedLocation,
      onDeselectAllExaminees,
      listOfSelectedExaminees,
      goBack,
      initialColumns,
      setNewHeaders,
      headerColumns,
      selectedExamCategory,
      onSelectAll,
      itemsTotalCount,
      openDeniedModal,
      openAbsentModal,
    } = this.props;
    let pager = this.state.pager;

    if (!pager.pages) {
      // don't display pager if there is only 1 page
      return null;
    }
    const width = window.innerWidth;
    const isMobile = width < 768;

    return (
      <div className="pagination-container">
        {displayHeader && (
          <div className="pagination-header">
            <div className="counter-size-container">
              <Counter
                itemsTotalCount={this.props.itemsTotalCount}
                totalCount={pager.totalItems}
                end={pager.endIndex + 1}
                start={pager.startIndex + 1}
                isMobile={isMobile}
                pager={pager}
              />
              {isMobile && (
                <ColumnManager
                  headerColumns={headerColumns}
                  initialColumns={initialColumns}
                  setNewHeaders={setNewHeaders}
                  tab={selectedExamCategory}
                />
              )}
              {pageSizeOptions && pageSizeOptions.length && isMobile && (
                <PageSizeSelect
                  pageSizeOptions={pageSizeOptions}
                  pager={pager}
                  onChangePageSize={this.onChangePageSize}
                  pageOptionsLabel={pageOptionsLabel}
                  itemsTotalCount={itemsTotalCount}
                  className="page-size-select-container"
                />
              )}
            </div>
            <div className="pagination-settings">
              <RostersAssign
                onReloadExaminees={onReloadExaminees}
                selectedLocation={selectedLocation}
                onDeselectAllExaminees={onDeselectAllExaminees}
                listOfSelectedExaminees={listOfSelectedExaminees}
                goBack={goBack}
                onSelectAll={onSelectAll}
                openAbsentModal={openAbsentModal}
                openDeniedModal={openDeniedModal}
              />
              {!isMobile && (
                <ColumnManager
                  headerColumns={headerColumns}
                  initialColumns={initialColumns}
                  setNewHeaders={setNewHeaders}
                  tab={selectedExamCategory}
                />
              )}

              {pageSizeOptions && pageSizeOptions.length && !isMobile && (
                <PageSizeSelect
                  pageSizeOptions={pageSizeOptions}
                  pager={pager}
                  onChangePageSize={this.onChangePageSize}
                  pageOptionsLabel={pageOptionsLabel}
                  itemsTotalCount={itemsTotalCount}
                  className="page-size-select-container"
                />
              )}
              <PageSelection
                showNumbersList={showNumbersList}
                showCurrentPage={showCurrentPage}
                showSelectPage={showSelectPage}
                pager={pager}
                setPage={this.setPage}
              />
            </div>
          </div>
        )}
        <div className="pagination-body">{children}</div>
      </div>
    );
  }
}
const Counter = ({ itemsTotalCount, totalCount, end, start, isMobile, pager }) => {
  const { t } = useTranslation();

  if (totalCount <= pager.pageSize) {
    return (
      <p className="counter-results">
        <strong>{`${itemsTotalCount} `}</strong>
        {totalCount === 1 ? t('rosters.examineeOfLabel') : t('rosters.examineesOfLabel')}
      </p>
    );
  }
  return (
    <p className="counter-results">
      {totalCount > 0 ? (
        <span>
          <strong>
            {start}-{end}
          </strong>{' '}
          {t('common.labels.outOf')} <strong>{totalCount} </strong>{' '}
          {isMobile
            ? t('rosters.results')
            : totalCount === 1
            ? t('rosters.examineeOfLabel')
            : t('rosters.examineesOfLabel')}
        </span>
      ) : (
        <strong>{t('common.labels.zeroResults')}</strong>
      )}
    </p>
  );
};

const PageSelection = (props) => (
  <div className="pagination">
    <button
      className={props.pager.currentPage === 1 ? 'disabled' : ''}
      tabIndex="0"
      onClick={() => props.setPage(1)}>
      <FirstPageIcon />
    </button>
    <button
      className={props.pager.currentPage === 1 ? 'disabled' : ''}
      tabIndex="0"
      onClick={() => props.setPage(props.pager.currentPage - 1)}>
      <PrevPageIcon />
    </button>
    {props.showNumbersList &&
      props.pager.pages.map((page, index) => (
        <span
          key={index}
          className={props.pager.currentPage === page ? 'active' : ''}
          tabIndex="0"
          onClick={() => props.setPage(page)}>
          <span>
            Page {props.pager.currentPage}/{props.pager.totalPages}
          </span>
        </span>
      ))}
    {props.showCurrentPage && (
      <span>
        Page {props.pager.currentPage}/{props.pager.totalPages}
      </span>
    )}
    {props.showSelectPage && (
      <Dropdown
        customClass="select-page"
        title={`Page ${props.pager.currentPage}/${props.pager.totalPages}`}
        name="page-select"
        isDropdownAvailable={props.pager.pages && props.pager.pages.length > 1}
        chevron={<DropdownArrow />}>
        {props.pager.pages.map((page, index) => (
          <DropdownItem
            tabIndex="0"
            key={index}
            handleClick={() => props.setPage(page)}
            text={`${page}/${props.pager.totalPages}`}
          />
        ))}
      </Dropdown>
    )}
    <button
      tabIndex="0"
      className={props.pager.currentPage === props.pager.totalPages ? 'disabled' : ''}
      onClick={() => props.setPage(props.pager.currentPage + 1)}>
      <NextPageIcon />
    </button>
    <button
      tabIndex="0"
      className={props.pager.currentPage === props.pager.totalPages ? 'disabled' : ''}
      onClick={() => props.setPage(props.pager.totalPages)}>
      <LastPageIcon />
    </button>
  </div>
);

const PageSizeSelect = (props) => {
  const { t } = useTranslation();
  return (
    <div className={props.className}>
      {props.pageOptionsLabel && <span className="pe-2">{props.pageOptionsLabel}</span>}

      <Dropdown
        customClass={`select-page-size ${!props.itemsTotalCount ? 'desabled' : ''}`}
        title={props.pager.pageSize}
        name="page-select"
        isDropdownAvailable={props.itemsTotalCount ? true : false}
        chevron={<DropdownArrow />}>
        {props.pageSizeOptions.map((element, index) => (
          <DropdownItem
            tabIndex="0"
            key={index}
            handleClick={() => props.onChangePageSize(element)}
            text={element}
          />
        ))}
      </Dropdown>
      <span>{t('common.labels.perPage')}</span>
    </div>
  );
};

Pagination.propTypes = {
  itemsTotalCount: PropTypes.number.isRequired,
  items: PropTypes.array,
  onChangePage: PropTypes.func.isRequired,
  initialPage: PropTypes.number,
  displayHeader: PropTypes.bool,
  showNumbersList: PropTypes.bool,
  showCurrentPage: PropTypes.bool,
  pageSize: PropTypes.number,
  pageOptionsLabel: PropTypes.string,
  paginationDataParams: PropTypes.shape({}),
};

Pagination.defaultProps = {
  initialPage: 1,
  pageSize: 10,
  showNumbersList: false,
  showCurrentPage: false,
  showSelectPage: false,
  displayHeader: true,
  pageOptionsLabel: '',
  paginationDataParams: {},
};
export default Pagination;
